import React from 'react';
import Lottie from 'react-lottie';

import {
  ModalContent,
  Text,
  Space,
  Button,
  Conditional,
} from '@cashfree-intl/coherent';

import CustomIcons from 'components/CustomIcons';

// Styled
import { StyledReviewModal } from '../styled';

// Constants
import { successAnimationOptions } from '../constants';

// Types
import { ReviewModalProps } from '../types';

const ReviewModal = ({ onClose, isPayoutsUpdated }: ReviewModalProps) => (
  <StyledReviewModal open $maxWidth={502} data-testid="review-modal">
    <ModalContent>
      <Space alignItems="center" direction="column">
        <Lottie options={successAnimationOptions} height={100} width={150} />
        <Text variant="h16">Bank details submitted</Text>
        <Text variant="h20" color="bodyLight" className="title">
          We are verifying your bank details
        </Text>
        <Text variant="b14" color="primary" className="chip">
          Usually takes less than 48 hours
        </Text>
        <CustomIcons componentName="STAR" />
        <Text variant="h16" className="mt-3">
          Details will be updated for
        </Text>
        <Text variant="b14" className="mt-4px">
          Payment Gateway
        </Text>
        <Conditional if={isPayoutsUpdated}>
          <Text variant="b14" className="mt-4px">
            Payouts
          </Text>
        </Conditional>
        <Button primary className="mt-3 mb-1" onClick={onClose}>
          Okay
        </Button>
      </Space>
    </ModalContent>
  </StyledReviewModal>
);

export default ReviewModal;
